import { BoxV2 as Box } from 'portal-commons';
import { FunctionComponent, useEffect, useState } from 'react';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';

import AcceptedCnpCampaigns from './AcceptedCnpCampaigns';
import DeclinedCnpCampaigns from './DeclinedCnpCampaigns';
import PendingCnpCampaigns from './PendingCnpCampaigns';
import { ListingTab } from '../components';
import {
  CNP_CAMPAIGNS_DEFAULT_ENTRY,
  CNP_CAMPAIGNS_HISTORY_DEFAULT_ENTRY,
  CNP_CAMPAIGNS_HISTORY_PATH,
  CNP_CAMPAIGNS_PATH,
  DECLINED_CNP_CAMPAIGNS_DEFAULT_ENTRY,
  DECLINED_CNP_CAMPAIGNS_PATH,
} from '@/constants/paths';

enum CnpCampaignType {
  Accepted = 'accepted',
  Pending = 'pending',
  Declined = 'declined',
}

const CnpCampaignTabItems = [
  {
    key: CnpCampaignType.Accepted,
    label: 'Accepted',
  },
  {
    key: CnpCampaignType.Pending,
    label: 'Pending',
  },
  {
    key: CnpCampaignType.Declined,
    label: 'Declined',
  },
];

const CnpCampaignUrls: Record<string, string> = {
  [CnpCampaignType.Accepted]: CNP_CAMPAIGNS_HISTORY_DEFAULT_ENTRY,
  [CnpCampaignType.Pending]: CNP_CAMPAIGNS_DEFAULT_ENTRY,
  [CnpCampaignType.Declined]: DECLINED_CNP_CAMPAIGNS_DEFAULT_ENTRY,
};

const findActiveTab = (path: string) => {
  const record = Object.entries(CnpCampaignUrls).find(
    ([_, url]) => url.split('?')[0] === path
  );
  return record?.[0] ?? '';
};

const CnpCampaignsPage: FunctionComponent = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [tab, setTab] = useState('');

  const handleTabChange = (newTab: string) => {
    setTab(newTab);
    const url = CnpCampaignUrls[newTab];
    if (url) {
      history.push(url);
    }
  };

  useEffect(() => {
    const newTab = findActiveTab(pathname);
    setTab(newTab);
  }, [pathname]);

  return (
    <Box sx={{ mt: -5 }}>
      <ListingTab
        items={CnpCampaignTabItems}
        activeTab={tab}
        onTabChange={handleTabChange}
      />
      <Box sx={{ paddingTop: '16px' }}>
        <Switch>
          <Route
            exact
            path={CNP_CAMPAIGNS_HISTORY_PATH}
            component={AcceptedCnpCampaigns}
          />
          <Route
            exact
            path={CNP_CAMPAIGNS_PATH}
            component={PendingCnpCampaigns}
          />
          <Route
            exact
            path={DECLINED_CNP_CAMPAIGNS_PATH}
            component={DeclinedCnpCampaigns}
          />
        </Switch>
      </Box>
    </Box>
  );
};

export default CnpCampaignsPage;
